/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Fade from 'react-reveal/Fade';
import Header from 'parts/Header';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';

export default class ContactPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header {...this.props} />
        <section className="pt-32 pb-24">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">
                Contact Us
              </h1>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-16 max-w-3xl mx-auto">
                Get in touch with us. We&apos;d love to hear from you and discuss how we can help
                transform your business.
              </p>
            </Fade>
          </div>
        </section>
        <Discuss {...this.props} />
        <Footer />
      </>
    );
  }
}
